/**
 * Grades Service
 * Handles fetching grade data
 */

import { httpClient } from '../lib/httpClient';
import { globalConfig } from '../config/globalConfig';
import type { GradesResponse, GradesQueryParams } from '../interfaces/apiInterfaces/grades';

/**
 * Fetch grades list with optional filters
 * @param params - Query parameters for filtering, pagination
 * @returns Grades list with pagination info
 */
export async function fetchGrades(params?: GradesQueryParams): Promise<GradesResponse> {
  try {
    // Fetch all grades by setting large page size
    const defaultParams: GradesQueryParams = {
      page_number: globalConfig.defaultPageNumber,
      page_size: globalConfig.defaultPageSize,
      ...params,
    };
    const response = await httpClient.get<GradesResponse>(
      '/v1/grades',
      { params: defaultParams }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching grades:', error);
    throw error;
  }
}
